export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14169.b585563b.jpg";